// extracted by mini-css-extract-plugin
module.exports = {"allBrands":"brands-module--all-brands--Fm_4n","flexContainer":"brands-module--flex-container--1jZ9U","flexItem":"brands-module--flex-item--23oB4"};